import { ReportsApiClient } from '@fourthwall/services/dist/ReportsApiClient'
import { useMutation } from '@tanstack/react-query'

import { exportReportCSV } from '../utils/exportReportCSV'
import { useAnalyticsQueryParams } from './useAnalyticsQueryParams'

type Params = Parameters<typeof ReportsApiClient.getReportCSV>

export const useExportAnalyticsReportCSV = () => {
  const analyticsQueryParams = useAnalyticsQueryParams()
  const { mutateAsync } = useMutation({
    mutationFn: async (params: Params) => {
      const { data } = await ReportsApiClient.getReportCSV(...params)

      return data
    },
  })

  const handleExport = async ({
    reportId,
    filters,
  }: {
    reportId: string
    filters?: Record<string, string>
  }) => {
    const filtersParams = filters ?? {}
    const data = await mutateAsync([
      { id: reportId },
      { ...analyticsQueryParams, ...filtersParams },
    ])

    if (data) {
      exportReportCSV(data, `${reportId}.csv`)
    }
  }

  return {
    exportReportCSV: handleExport,
  }
}
